import formatSelectedItemsContext from 'common/src/modules/shared/copilot/utils/formatSelectedItemsContext';
import {AgentContext} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';

type CreativeTemplatesLibraryContext = {
  selectedTemplates: {
    id: number;
    name: string;
  }[];
};

export default function creativeTemplatesLibraryContext(
  store: CLStore,
): AgentContext<CreativeTemplatesLibraryContext> {
  return {
    title: 'Creative Templates library',
    getter: (): CreativeTemplatesLibraryContext => {
      const {templates, selectedTemplatesIds} = store.getState().creativeTemplatesLibrary;

      const selectedTemplates = templates
        .filter((template) => selectedTemplatesIds.includes(template.id))
        .map((template) => ({
          id: template.id,
          name: template.name,
        }));

      return {selectedTemplates};
    },

    formatter: ({currentContext}) => {
      return formatSelectedItemsContext({
        items: currentContext.selectedTemplates,
        itemTypeName: 'creative template',
      });
    },
  };
}
